import { render } from "./UserContactList.vue?vue&type=template&id=946bcdce"
import script from "./UserContactList.vue?vue&type=script&lang=js"
export * from "./UserContactList.vue?vue&type=script&lang=js"

import "./UserContactList.vue?vue&type=style&index=0&id=946bcdce&lang=scss"

import exportComponent from "/home/ubuntu/kokoroduke-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__